export const BUSBUD_POLICY_RULES_URL = "https://refundable.me/extended/busbud/";

export const ProductSection = {
  LEGACY: "legacy",
  TRAVEL_ADDONS: "travel_addons",
  TRIP_FARE_SUMMARY: "trip_fare_summary"
} as const;
export type ProductSection =
  (typeof ProductSection)[keyof typeof ProductSection];
